import { strollers_api_v2_get_brands_url } from 'mk/urls/functions';
import {
    strollersBrandsLoadApi,
    StrollersBrandsLoadAction,
    StrollersBrandsLoadApiNormalizedResponse,
    STROLLERS_BRANDS_LOAD,
} from 'mk2/apps/strollers/containers/Brands/Brands.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('strollers/Brands.sagas');

interface LoadApiResponse {
    body: {
        entities: StrollersBrandsLoadApiNormalizedResponse['entities'];
        result: StrollersBrandsLoadApiNormalizedResponse['result'];
        strollersCountPerBrand: Record<number, number>;
        hasMore: boolean;
    };
}

function* load({ after, xhr }: StrollersBrandsLoadAction & XHRAction) {
    yield put(strollersBrandsLoadApi.request(after));

    try {
        const response: LoadApiResponse = yield call(() => xhr.get(strollers_api_v2_get_brands_url({ after })));

        yield put(
            strollersBrandsLoadApi.success(after, response.body.hasMore, response.body.strollersCountPerBrand, {
                entities: response.body.entities,
                result: response.body.result,
            }),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(strollersBrandsLoadApi.failure(after, normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(STROLLERS_BRANDS_LOAD, load)]);
}
